@if (pageReady) {
  <main class="gs-page">
    <div class="update-login-info-container">
      <app-page-header [headerData]="headerData"></app-page-header>
      <div class="notification-container">
        <app-notification [pageName]="pageName"></app-notification>
      </div>
      <div class="gs-content-container">
        <form
          #formDirective="ngForm"
          [formGroup]="changePasswordForm"
          (ngSubmit)="onSubmit(formDirective)"
          class="changePassword-form"
        >
          <h2>Change Password</h2>
          <div class="update-login-info-form-container">
            <mat-form-field
              class="password-container remove-margin-bottom"
              appearance="outline"
              subscriptSizing="dynamic"
            >
              <mat-label id="passwordLabel">{{ pageLabels.changePasswordText }}</mat-label>
              <input
                matInput
                class="custom-input"
                [type]="passwordVisible ? 'text' : 'password'"
                formControlName="password"
                id="CreateNewPassword"
                data-private
                aria-labelledby="passwordLabel passwordReq passwordError pwMinLengthErr pwMaxLengthErr
                                pwMIsMatchError pwMeetsRequirments"
                (blur)="confirmPasswordMatch()"
                maxlength="12"
              />
              <button
                type="button"
                mat-icon-button
                matSuffix
                (click)="togglePasswordVisibility()"
                [attr.aria-label]="
                  passwordVisible ? pageLabels.hidePasswordAriaLabel : pageLabels.showPasswordAriaLabel
                "
              >
                <i
                  class="fa-solid fa-eye"
                  [class.fa-eye]="!passwordVisible"
                  [class.fa-eye-slash]="passwordVisible"
                  [class.eye-icon]="true"
                ></i>
              </button>
              @if (changePasswordForm.get("password")?.hasError("required")) {
                <mat-error id="passwordError">{{ pageLabels.passwordErrorText }}</mat-error>
              } @else if (changePasswordForm.get("password")?.hasError("minlength")) {
                <mat-error id="pwMinLengthErr">{{ pageLabels.passwordMinLengthError }}</mat-error>
              } @else if (changePasswordForm.get("password")?.hasError("maxlength")) {
                <mat-error id="pwMaxLengthErr">{{ pageLabels.passwordMaxLengthError }}</mat-error>
              } @else if (changePasswordForm.get("password")?.hasError("pwMeetsRequirments")) {
                <mat-error id="pwMeetsRequirments">{{ pageLabels.passwordMustMeetRequirementsError }}</mat-error>
              } @else if (changePasswordForm.get("password")?.hasError("passwordsDontMatch")) {
                <mat-error id="pwMIsMatchError">{{ pageLabels.passwordsDontMatchError }}</mat-error>
              }
            </mat-form-field>
            <div id="passwordReq" [attr.aria-label]="passwordAriaLabelText" class="passwordList">
              <p class="passwordRequirements">{{ pageLabels.passwordRequirementsText }}</p>
              <ul class="passwordListItems">
                @if (hasOneNumber) {
                  <li class="reqListItem">{{ pageLabels.passwordAtLeastOneNumberText }}</li>
                }
                @if (!hasOneNumber) {
                  <li>
                    <i role="img" aria-label="Satisfied" class="fa-solid fa-check fa-lg checkMark"></i
                    >{{ pageLabels.passwordAtLeastOneNumberText }}
                  </li>
                }
                @if (hasOneSpecialCharacter || charNotAllowed) {
                  <li class="reqListItem">{{ pageLabels.passwordAtLeastOneSpecialCharacterText }}</li>
                  <li class="reqListItemRegex">{{ passwordSpecialCharacterText }}</li>
                }
                @if (!hasOneSpecialCharacter && !charNotAllowed) {
                  <li>
                    <i role="img" aria-label="Satisfied" class="fa-solid fa-check fa-lg checkMark"></i
                    >{{ pageLabels.passwordAtLeastOneSpecialCharacterText }}
                  </li>
                  <li class="reqListItemRegex">{{ passwordSpecialCharacterText }}</li>
                }
                @if (hasLessthanSevenChar) {
                  <li class="reqListItem">{{ pageLabels.passwordAtLeast7To12CharactersLongText }}</li>
                }
                @if (!hasLessthanSevenChar) {
                  <li>
                    <i role="img" aria-label="Satisfied" class="fa-solid fa-check fa-lg checkMark"></i
                    >{{ pageLabels.passwordAtLeast7To12CharactersLongText }}
                  </li>
                }
              </ul>
            </div>

            <mat-form-field class="password-container" appearance="outline">
              <mat-label id="passwordConfirmLabel">{{ pageLabels.confirmPasswordText }}</mat-label>
              <input
                matInput
                class="custom-input"
                [type]="confirmPasswordVisible ? 'text' : 'password'"
                formControlName="confirmPassword"
                id="CreateNewPasswordConfirm"
                data-private
                aria-labelledby="passwordConfirmLabel passwordError confirmPwdError ConfirmPwMinLengthErr
                                ConfirmPwMaxLengthErr confirmedPasswordMisMatchError ConfirmPwMeetsRequirments"
                (blur)="confirmPasswordMatch()"
                maxlength="12"
              />
              <button
                type="button"
                mat-icon-button
                matSuffix
                (click)="toggleConfirmPasswordVisibility()"
                [attr.aria-label]="
                  confirmPasswordVisible ? pageLabels.hidePasswordAriaLabel : pageLabels.showPasswordAriaLabel
                "
              >
                <i
                  class="fa-solid fa-eye"
                  [class.fa-eye]="!confirmPasswordVisible"
                  [class.fa-eye-slash]="confirmPasswordVisible"
                  [class.eye-icon]="true"
                ></i>
              </button>
              @if (changePasswordForm.get("confirmPassword")?.hasError("required")) {
                <mat-error id="confirmPwdError">{{ pageLabels.passwordErrorText }}</mat-error>
              } @else if (changePasswordForm.get("confirmPassword")?.hasError("minlength")) {
                <mat-error id="ConfirmPwMinLengthErr">{{ pageLabels.passwordMinLengthError }}</mat-error>
              } @else if (changePasswordForm.get("confirmPassword")?.hasError("maxlength")) {
                <mat-error id="ConfirmPwMaxLengthErr">{{ pageLabels.passwordMaxLengthError }}</mat-error>
              } @else if (changePasswordForm.get("confirmPassword")?.hasError("confirmPwMeetsRequirments")) {
                <mat-error id="ConfirmPwMeetsRequirments">{{ pageLabels.passwordMustMeetRequirementsError }}</mat-error>
              } @else if (changePasswordForm.get("confirmPassword")?.hasError("passwords2DontMatch")) {
                <mat-error id="confirmedPasswordMisMatchError">{{ pageLabels.passwordsDontMatchError }}</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="cta-container">
            <div class="button-container">
              <button role="link" class="gs-form-button-primary" mat-flat-button color="primary">
                {{ pageLabels.changePasswordButtonText }}
              </button>
            </div>
          </div>
        </form>
        @if (showBiometricOption) {
          <form [formGroup]="bioForm" class="bio-form">
            <h2>{{ pageLabels.changeBiometricsHeader }}</h2>
            <div class="bio-form-container">
              <mat-slide-toggle formControlName="bio" color="primary" labelPosition="before" (change)="bioSubmit()">{{
                pageLabels.bioSlideText
              }}</mat-slide-toggle>
            </div>
          </form>
        }
        <div class="back-container">
          <a
            [routerLink]="pageLabels.changePasswordManageAccountLink.value.data.url"
            class="change-link"
            [attr.aria-label]="pageLabels.changePasswordManageAccountLinkAriaLabel"
            >{{ pageLabels.manageAccountLinkText }}</a
          >
        </div>
      </div>
    </div>

    <ng-template #bioPopup>
      <h2 mat-dialog-title>{{ pageLabels.bioPopupHeader }}</h2>
      <mat-dialog-content>
        <p>{{ pageLabels.bioPopupMessage }}</p>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button class="gs-form-button-primary cancel-button" mat-button [mat-dialog-close]="false">
          {{ pageLabels.bioPopupCancelButtonText }}
        </button>
        <button class="gs-form-button-primary" mat-flat-button color="primary" [mat-dialog-close]="true">
          {{ pageLabels.bioPopupConfirmButtonText }}
        </button>
      </mat-dialog-actions>
    </ng-template>

    <ng-template #bioEnrollPopup>
      <mat-dialog-content>
        <p>{{ pageLabels.bioEnrollPopupHeader }}</p>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button class="gs-form-button-primary cancel-button" mat-button [mat-dialog-close]="false">
          {{ pageLabels.bioEnrollPopupCancelButtonText }}
        </button>
        <button class="gs-form-button-primary" mat-flat-button color="primary" [mat-dialog-close]="true">
          {{ pageLabels.bioEnrollPopupConfirmButtonText }}
        </button>
      </mat-dialog-actions>
    </ng-template>

    <ng-template #bioCancelPopup>
      <mat-dialog-content>
        <p>{{ pageLabels.bioCancelPopupHeader }}</p>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button class="gs-form-button-primary cancel-button" mat-button [mat-dialog-close]="false">
          {{ pageLabels.bioCancelPopupCancelButtonText }}
        </button>
        <button class="gs-form-button-primary" mat-flat-button color="primary" [mat-dialog-close]="true">
          {{ pageLabels.bioCancelPopupConfirmButtonText }}
        </button>
      </mat-dialog-actions>
    </ng-template>
  </main>
}
